export function getSideNavActiveHref(pathname: string) {
  if (pathname.startsWith('/conferences')) {
    return '#/conferences';
  } else if (pathname.startsWith('/venuevsbuild')) {
    return '#/venuevsbuild';
  } else {
    return `#${pathname}`;
  }
}
